import { CartFragment } from './fragments/cart-fragment';

export const cartLinesRemove = /* GraphQL */ `
  mutation cartLinesRemove($country: CountryCode, $cartId: ID!, $lineIds: [ID!]!)
  @inContext(country: $country) {
    cartLinesRemove(cartId: $cartId, lineIds: $lineIds) {
      cart {
        ${CartFragment}
      }
      userErrors {
        field
        message
      }
    }
  }
`;
